export const SET_BRAND_UI_FLAG = 'SET_BRAND_UI_FLAG';
export const CLEAR_BRANDS = 'CLEAR_BRANDS';
export const SET_BRANDS = 'SET_BRANDS';
export const SET_BRAND_ITEM = 'SET_BRAND_ITEM';
export const EDIT_BRAND = 'EDIT_BRAND';
export const DELETE_BRAND = 'DELETE_BRAND';
export const ADD_AGENTS_TO_BRAND = 'ADD_AGENTS_TO_BRAND';
export const UPDATE_BRANDS_PRESENCE = 'UPDATE_BRANDS_PRESENCE';
